import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { BrandFlaggedMessage, adminListFlaggedBrandMessages } from '../../api/payment/brand-thread.api';
import BrandThreadPanel from './brand-thread-panel';

/** Tab admin "Tin nhắn có cờ" (spec 2026-10-12 §3.1): tin có số điện thoại, email, zalo, telegram, facebook — mới nhất trước,
 * bấm "Xem phòng" mở cả dòng thời gian chỉ đọc. */

const formatDateTime = (iso: string) => new Date(iso).toLocaleString('vi-VN', { hour12: false });

const FlaggedRow: React.FC<{ item: BrandFlaggedMessage; onOpen: () => void }> = ({ item, onOpen }) => (
  <tr className="border-b border-gray-200 align-top dark:border-gray-700">
    <td className="whitespace-nowrap p-2 text-xs text-gray-500">{formatDateTime(item.createdAt)}</td>
    <td className="p-2 text-sm dark:text-white">
      <div>{item.campaignTitle}</div>
      <div className="text-xs text-gray-500">{item.creatorName}</div>
    </td>
    <td className="p-2 text-xs dark:text-gray-300">{item.senderRole === 'Creator' ? 'Creator' : 'Người đặt'}</td>
    <td className="max-w-[360px] whitespace-pre-wrap break-words p-2 text-sm dark:text-white">{item.text}</td>
    <td className="p-2">
      <button type="button" onClick={onOpen} className="rounded border border-blue-600 px-2 py-1 text-xs text-blue-600">
        Xem phòng
      </button>
    </td>
  </tr>
);

const AdminFlaggedMessages: React.FC = () => {
  const [page, setPage] = useState(1);
  const [items, setItems] = useState<BrandFlaggedMessage[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [openThreadId, setOpenThreadId] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    adminListFlaggedBrandMessages(page)
      .then((res) => {
        setItems(res.items);
        setTotalPages(res.totalPages);
      })
      .catch(() => toast.error('Không tải được tin nhắn có cờ.'))
      .finally(() => setLoading(false));
  }, [page]);

  return (
    <div className="space-y-3">
      {loading ? (
        <p className="text-gray-500">Đang tải…</p>
      ) : items.length === 0 ? (
        <p className="text-gray-500">Chưa có tin nhắn nào bị gắn cờ.</p>
      ) : (
        <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white dark:border-gray-700 dark:bg-boxdark">
          <table className="w-full text-left">
            <thead>
              <tr className="border-b border-gray-200 text-xs text-gray-500 dark:border-gray-700">
                <th className="p-2">Lúc gửi</th>
                <th className="p-2">Chiến dịch</th>
                <th className="p-2">Người gửi</th>
                <th className="p-2">Nội dung</th>
                <th className="p-2" />
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <FlaggedRow key={item.messageId} item={item} onOpen={() => setOpenThreadId(item.threadId)} />
              ))}
            </tbody>
          </table>
        </div>
      )}

      {totalPages > 1 && (
        <div className="flex items-center gap-2 text-sm">
          <button type="button" disabled={page <= 1} onClick={() => setPage((p) => p - 1)} className="rounded border px-3 py-1 disabled:opacity-40">
            Trước
          </button>
          <span className="text-gray-500">
            Trang {page}/{totalPages}
          </span>
          <button
            type="button"
            disabled={page >= totalPages}
            onClick={() => setPage((p) => p + 1)}
            className="rounded border px-3 py-1 disabled:opacity-40"
          >
            Sau
          </button>
        </div>
      )}

      {openThreadId && (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 p-4" onClick={() => setOpenThreadId(null)}>
          <div
            className="max-h-[90vh] w-full max-w-[640px] overflow-y-auto rounded-2xl bg-white p-6 shadow-xl dark:bg-slate-800"
            onClick={(e) => e.stopPropagation()}
          >
            <BrandThreadPanel threadId={openThreadId} mode="admin" showHeader />
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminFlaggedMessages;
